import { BookingState, ICalendarEventType, PharmacistLegendVariant } from '@pharmaplan/common';

const { UpdatedTiming } = BookingState;
const { booked } = PharmacistLegendVariant;

export const showConfirmBox = (bookingState: BookingState, eventType: ICalendarEventType) => {
  const isUpdatedTiming = bookingState === UpdatedTiming;

  const isBooked = eventType === booked;

  if (isBooked) {
    return isUpdatedTiming;
  }

  return false;
};
